/**
 * Utility function to combine multiple report strings
 * This is a pure function that doesn't use React hooks
 */
export const combineMultipleReports = (reportStrings: (string | undefined)[]): string => {
  const validStrings = reportStrings.filter((str): str is string => str !== undefined && str.trim() !== '')

  if (validStrings.length === 0) {
    return ''
  }

  return validStrings.join('\n\n')
}
